import Component from '@glimmer/component';

import { concat } from '@ember/helper';
import { on } from '@ember/modifier';
import noop from '@nullvoxpopuli/ember-composable-helpers/helpers/noop';
import queue from '@nullvoxpopuli/ember-composable-helpers/helpers/queue';

import concatClasses from 'rise-ui/helpers/concat-classes.js';
import fnx from 'rise-ui/helpers/fnx.js';

export default class DropdownListButtonItemComponent extends Component {
  <template>
    <div role="menuitem"
      class={{concatClasses
        @mixClass
        (if @disabled "disabled")
        (concat "qa-ddlbi--" @key)
      }}
      {{on "click" (if @disabled (noop) (queue (fnx @onSelection @key) (fnx @onClick @key)))}}
      ...attributes
    >
      {{~yield~}}
    </div>
  </template>
}
